export enum EGeofenceType {
    Polygon = 0,
    Circle = 1
} 